import T from 'prop-types';
import React from 'react';
import { TextInput } from '@acast/decibel';
import Field from 'shared/components/field';

const LinkUrlField = ({ error, onChange, value }) => (
  <Field label="URL" name="link-url" meta={{ error, touched: true }}>
    <TextInput value={value || ''} onChange={event => onChange(event.target.value)} />
  </Field>
);

LinkUrlField.propTypes = {
  error: T.string,
  onChange: T.func.isRequired,
  value: T.string,
};

LinkUrlField.defaultProp = {
  error: undefined,
  value: '',
};

export default LinkUrlField;
